import script from "./SitemapBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SitemapBlock.vue?vue&type=script&setup=true&lang=js"

import "./SitemapBlock.vue?vue&type=style&index=0&id=59d1542e&lang=scss"

const __exports__ = script;

export default __exports__